<p-dialog
  header="Cambiar límites"
  [visible]="visible()"
  (visibleChange)="!$event && close()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!saving()"
  appendTo="body"
  [style]="{ width: 'min(40rem, calc(100vw - 2rem))' }">
  <div class="flex flex-col gap-4 pt-1">
    <p class="text-sm text-slate-600 m-0">
      Bajar límites aplica de inmediato. Subir cualquier límite queda <strong>pendiente</strong> hasta que el cliente lo acepte;
      mientras tanto se siguen aplicando los actuales.
    </p>
    <app-mit-limits-fields [form]="form()" idPrefix="mit-edit" />
    @if (error()) {
      <p class="text-sm text-red-600 m-0">{{ error() }}</p>
    }
  </div>
  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button label="Cerrar" severity="secondary" [text]="true" type="button" [disabled]="saving()" (onClick)="close()" />
      <p-button label="Guardar límites" icon="pi pi-check" type="button" [loading]="saving()" (onClick)="save()" />
    </div>
  </ng-template>
</p-dialog>
